import React , {Fragment } from 'react';
import LayoutOne from "../layouts/LayoutOne";
import ContactForm from '../components/ContactForm'
import PageHeader from '../components/PageHeader'
import Seo from '../components/Seo';

const ContactPage = () => {

    return(

        <Fragment>
            <Seo
              title="Contact Navy Seals Moving | Free Moving Estimates"
              description="Get an accurate moving quote by video call or in-person visit. Call Navy Seals Moving at (206) 636-6961 or send us a message, open Mon–Sat 9am–9pm, Sun 9am–1pm."
            />

            <LayoutOne>
              <PageHeader
                bgImg={(process.env.PUBLIC_URL + '/assets/images/page_bg.jpg')}
                title="Contact Us"
              />
              
              <ContactForm />

            </LayoutOne>
        </Fragment>

      );
  }

     

export default ContactPage;   